import React, { forwardRef, useEffect } from 'react';
import { isNil } from 'lodash';

interface Props {
  disabled?: boolean;
  id?: string;
  isChecked: boolean;
  onChange?: any;
  children: any;
  indeterminate?: boolean;
}

const CommonCheckBox = forwardRef<any, Props>(
  (
    {
      disabled = false,
      id,
      children,
      isChecked = false,
      onChange,
      indeterminate,
    },
    ref: any
  ) => {
    useEffect(() => {
      if (!isNil(indeterminate)) {
        ref!.current.indeterminate = indeterminate;
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
      <div className="flex items-center">
        <input
          type="checkbox"
          id={id}
          className="cursor-pointer accent-magenta min-w-[2.2rem] max-w-[2.2rem] h-2.2 flex flex-1"
          disabled={disabled}
          checked={isChecked}
          ref={ref}
          onChange={onChange}
          readOnly
        />
        <div className="leading-9 ml-1 text-16 w-full flex flex-1">
          {children}
        </div>
      </div>
    );
  }
);
export default CommonCheckBox;
